
const GetIntegrations = 
  `query Query($count: Int, $cursor: String, $filterConfig: IntegrationFilterConfigInput) {
    integrations(first: $count, after: $cursor, filterConfig: $filterConfig) {
        pageInfo { hasNextPage }
        edges {
          cursor
          node {
            id
            name
            description
            sender {
              id
              name
              description
            }            
            receiver {
              id
              name
            }            
            dataType {
              id
              name
              description
            }
          }
        }
      }
    }
    `

const GetIntegration = `query Query($id: String!) {
    integration(id: $id) {
      id
      name
      description
      dataType {
        id
        name
        description
      }
      receiver {
        id
        name
        description
      }
      sender {
        id
        name
        description
      }
      deliveryConfig {
        id
        name
        description  
      }
      dataSources {
        id
        name
        description
      }
      steps {
        type
        config {
          __typename
          ...on ReRoutingStepConfig {
            sender {
              id
              name
              description
            }
            receiver {
              id
              name
              description
            }
            dataType {
              id
              name
              description
            }
          }
          ...on TrimLineStepConfig {
            encoding
            endOfLineCharacter
          }
          ...on LookupStepConfig {
            tableId
            metadataSearchKey
            missingLookupRoutingConfig {
              sender {
                id
              }
              receiver {
                id
              }
              dataType {
                id
              }
            }
          }
          ...on BranchStepConfig {
            sender {
              id
              name
              description
            }
            receiver {
              id
              name
              description
            }
            dataType {
              id
              name
              description
            }
          }
          ...on XMLXFormStepConfig {
            splitXPath
            delimiter
            xmlToFFMappings {
              id
              fieldLength
              padLeft
              padChar
              xpath
              customFnName
            }
          }
          ...on GLXFormStepConfig {
            glMappingInput {
              iDocType
              mesTyp
              mesCod
              sndPor
              sndPrt
              sndPrn
              rcvPor
              rcvPrn
              username
              docType
              companyCodeMap
            }
          }
          ...on PayReqXFormStepConfig {
            payReqMappingInput {
              direct
              iDocType
              mesTyp
              mesCod
              sndPor
              sndPrn
              rcvPor
              rcvPrn
              username
              busAct
              docAdjustTypeMap
            }
          }
          ... on MetadataRoutingStepConfig {
            metadataKey
            routes {
              match
              sender {
                id
              }
              receiver {
                id
              }
              dataType {
                id
              }
            }
          }
          ... on MetadataDedupeConfig {
            dedupeKeys
          }
          ... on XSDValidationConfig {
            xsd
          }
          ... on XMLExtractConfig {
            xpath
          }
          ... on DocumentWrapperConfig {
            header
            footer
          }
          ... on MetadataMappingConfig {
            mappings {
              toKey
              fromKey
              map {
                toValue
                fromValue
              }
              defaultValue
            }
          }
          ... on RegexMetadataExtractionConfig {
            regexes {
              key
              regex
            }
          }
          ... on XMLSplitStepConfig {
            xpath
            sender {
              id
              name
              description
            }
            receiver {
              id
              name
              description
            }
            dataType {
              id
              name
              description
            }
          }
          ... on FlatFileSplitStepConfig {
            batchSize
            preserveHeader
            endOfLineCharacter
            sender {
              id
              name
              description
            }
            receiver {
              id
              name
              description
            }
            dataType {
              id
              name
              description
            }
          }
          ... on BatchStagingStepConfig {
            batchId
            nextActionTime
            batchSchedule
          }
          ... on BatchAppendStepConfig {
            delimiter
          }
        }
      }
    }
  }
  `

module.exports = {
  GetIntegrations,
  GetIntegration,  
}